import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How do you handle freight between Europe and India?",
  answer: "We partner with a network of verified logistics providers offering comprehensive air, sea, and land freight solutions tailored to your specific cargo requirements across both regions.",
  linkText: "",
  linkUrl: ""
}, {
  question: "Do you assist with customs clearance and import/export regulations?",
  answer: "Yes, our platform connects you with experts who navigate complex customs procedures. For detailed compliance guides and documentation requirements, visit our ",
  linkText: "Regulatory Navigator.",
  linkUrl: "/RegulatoryPage"
}, {
  question: "Can I track my cross-border shipments through the platform?",
  answer: "While we connect you with trusted logistics partners, tracking is typically handled directly through the chosen provider's dedicated system to ensure real-time accuracy and security.",
  linkText: "",
  linkUrl: ""
}, {
  question: "What types of goods can be shipped using your logistics network?",
  answer: "Our network supports a wide range of goods, from industrial machinery to consumer products, ensuring compliance with the EU–India Free Trade Agreement standards and local regulations.",
  linkText: "",
  linkUrl: ""
}, {
  question: "How do I find a reliable logistics partner for my specific industry?",
  answer: "You can browse our verified directory of logistics and freight services, filtering by industry expertise, route capabilities, and service types to find the perfect match for your supply chain.",
  linkText: "Explore Trade Services.",
  linkUrl: "/TradeServicesPage"
}];
export default function ServiceLogisticsFaq() {
  return <section id="service-logistics-faq" className="bg-muted/50 py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4 font-sans">
            Service Logistics FAQ
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Find answers to common questions about our cross-border logistics, freight solutions, and supply chain management between Europe and India.
          </p>
        </div>

        <div className="bg-background rounded-2xl shadow-sm border border-border p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-base md:text-lg font-bold font-sans text-left hover:text-primary hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed text-base">
                  {faq.answer}
                  {faq.linkText && faq.linkUrl && <Link to={faq.linkUrl} className="text-primary font-medium hover:underline inline-flex items-center">
                      {faq.linkText}
                    </Link>}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}